
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.header{
  border-bottom:1px solid #eee;
}

.user-navigation {
  background-color: var(--blue-responsible-lighten-5);
  color: var(--blue-responsible-main);
  padding: 1rem;
}

@media (min-width: 1280px) {

  .user-navigation {
    padding: 0.5rem;
  }
}

@media (min-width: 1440px) {

  .user-navigation {
    padding: 1rem;
  }
}

.user-navigation {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

@media (min-width: 1280px) {

  .user-navigation {
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
  }
}

@media (min-width: 1440px) {

  .user-navigation {
    font-size: var(--fs-base);
    line-height: var(--lh-base);
  }
}

.user-navigation outline-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.language {
  flex-shrink: 1;
}

.utility {
  align-self: center;
  padding-left: 1.5rem;
  padding-right: 0.5rem;
}

.primary {
  width: 100%;
  align-self: flex-end;
}

.primary[aria-hidden='true']{
  width:calc(100% - 2.5rem);
}

.search {
  display: flex;
  align-self: center;
}

.primary-navigation {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--blue-responsible-main);
}

@media (min-width: 1280px) {

  .primary-navigation {
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
  }
}

@media (min-width: 1440px) {

  .primary-navigation {
    font-size: var(--fs-base);
    line-height: var(--lh-base);
  }
}

.primary-navigation {
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1.5rem;
}

@media (min-width: 1024px) {

  .primary-navigation {
    padding-left: 1.5rem;
  }
}

@media (min-width: 1280px) {

  .primary-navigation {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .primary-navigation {
    padding-left: 0.5rem;
  }

  .primary-navigation {
    padding-right: 1rem;
  }
}

@media (min-width: 1440px) {

  .primary-navigation {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}

.primary-navigation .logo, .primary-navigation .search, .primary-navigation .mobile-menu-open, .primary-navigation .mobile-menu-close {
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl);
}

@media (min-width: 1024px){
  .primary-navigation {
    flex-wrap: nowrap;
  }
  .primary {
    flex-grow: 1;
  }
  .primary {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (min-width: 1280px){
  .primary {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}

@media (min-width: 1440px){
  .primary {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}
`;